export const _persianDigit = (s: string | number) =>
    s
        .toString()
        .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)])
        .replaceAll(',', '٬');
